import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import printJS from 'print-js';
import loader from '../../../../../loader.gif'
import { 
   Menu, Icon, Label, Form, Select, Button, Loader, Pagination, Message
} from 'semantic-ui-react';
import _ from 'lodash';
import { DateRangePicker, isInclusivelyBeforeDay } from 'react-dates';
import swal from 'sweetalert'
import moment from 'moment'
import { getOPD } from '../../../../../_utils/localstorage';
import exportFromJSON from 'export-from-json' 

const fileName = `rekening-pendapatan-${parseInt(new Date().getTime() / 1000)}`;  
const exportType = 'xls' 


export default class RekeningLaporan extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            requests: false,
            range: "",
            
            startDate: null,
            endDate: null,
            status_val: null,

            total:[],
            status:[],
            jumlah:0,
            semua:true,
            semua_data:[],
            
            opds:[],
            opd_kode:null,
            opd_name:null,

            activePage:1,
            totalPages:0,
            penerimaan_rekening: [],
            task_id: null
        }
        this.onFilter = this.onFilter.bind(this);    
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
    }

    getResponseTask = (task_id) => {
        var self = this;
        setTimeout(() => {
            fetch(`${BaseURLDev}/report/penerimaanrekening/response?task_id=${task_id}`)
            .then(response => {
                if (!response.ok) { 
                    swal('Load data gagal',  { icon:'error' })
                    this.setState({requests: false});
                    return Promise.reject(response.statusText);
                }
                return response.json();
            })
            .then(resJSON => {
                if(resJSON.status === 'SUCCESS'){
                    self.setState({
                        penerimaan_rekening: resJSON.data,
                        requests: false,
                    });
                    self.ExportToExcel();
                    return;
                }
                self.getResponseTask(task_id)
            })
        }, 6000);
    }


    ExportToExcel = () => {  
        const data = this.state.penerimaan_rekening;
        const fileName = `pendapatan_${this.state.startDate.format('DD/MM/YYYY')}__${this.state.endDate.format('DD/MM/YYYY')}`;
        exportFromJSON({ data, fileName, exportType })  
    } 

    handlePaginationChange = (e, { activePage }) => {
        this.setState({ activePage, requests:true })
        fetch(`${BaseURLDev}/bp?report=true&page=${activePage}&status=1`,{headers})
        .then(response => {
            if (!response.ok) { 
                  return Promise.reject(response.statusText);
              }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                semua_data:semua_data,
                requests:false,
                totalPages:4,
            })
        });
    }

    onRefresh(){
        this.setState({
            startDate:null,
            endDate:null,
            requests:true
        })

        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }

    getBulan(e){
        if(e=='01') return 'Januari'
        else if(e=='02') return 'Februari'
        else if(e=='03') return 'Maret'
        else if(e=='04') return 'April'
        else if(e=='05') return 'Mei'
        else if(e=='06') return 'Juni'
        else if(e=='07') return 'Juli'
        else if(e=='08') return 'Agustus'
        else if(e=='09') return 'September'
        else if(e=='10') return 'Oktober'
        else if(e=='11') return 'November'
        else if(e=='12') return 'Desember'
    }

    onFilter(){
        const { startDate, endDate } = this.state;
        const start_date = startDate === null ? null : startDate.format('YYYY-MM-DD');
        const end_date = endDate === null ? null : endDate.format('YYYY-MM-DD');

        var self = this;
        if(startDate===null || endDate===null){
            swal('Pilih range tanggal dulu!',  { icon: 'error' });
            this.setState({ data: [] });
            return false;
        }

        this.setState({ requests: true });
        // fetch(`${BaseURLDev}/report/penerimaanrekening?start=${start_date}&end=${end_date}`,{headers})
        fetch(`${BaseURLDev}/report/penerimaanrekening/trigger?start=${start_date}&end=${end_date}`)
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            // console.log(resJSON);
            // swal('Load data selesai',  { icon:'success' });
            self.setState({
                task_id: resJSON.task_id,
                // requests: false,
                range: moment(start_date).format("DD")+" "+
                    this.getBulan(moment(start_date).format("MM"))+" "+
                    moment(start_date).format("YYYY")  +" s/d "+
                    moment(end_date).format("DD")+" "+
                    this.getBulan(moment(end_date).format("MM"))+" "+
                    moment(end_date).format("YYYY")
            });
            this.getResponseTask(resJSON.task_id)
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
            this.setState({requests: false});

        });
    }

    getData = () => {
        fetch(`${BaseURLDev}/bp?report=true`,{headers})
        .then(response => {
            if (!response.ok) { 
                swal('Load data gagal',  { icon:'error' })
                this.setState({requests:false});
                return Promise.reject(response.statusText);
            }
            return response.json();
        })
        .then(resJSON => {
            var tam1=[]; var status=[]; var jum=0; var semua_data=[];
            var jumBelumSTS=0; var jumSudahSTS=0; var jumVer=0;
            for(var i=0;i<resJSON.data.length;i++){
                var tam2=0; var stat="";
                for(var j=0; j<resJSON.data[i].rincian.length;j++){
                    tam2=tam2+resJSON.data[i].rincian[j].nilai;
                }
                if(resJSON.data[i].is_active===true && resJSON.data[i].is_verified===false){
                    stat="BP Non STS";
                    jumBelumSTS=jumBelumSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===false){
                    stat="BP STS";
                    jumSudahSTS=jumSudahSTS+1;
                } else if(resJSON.data[i].is_active===false && resJSON.data[i].is_verified===true){
                    stat="BP Terealisasi";
                    jumVer=jumVer+1;
                }
                tam1[i]=tam2;
                jum=jum+tam2;
                status[i]=stat;
            }
            semua_data[0]=jumBelumSTS;
            semua_data[1]=jumSudahSTS;
            semua_data[2]=jumVer;
            this.setState({
                data:resJSON.data,
                status:status,
                total:tam1,
                jumlah:jum,
                totalPages:4,
                semua_data:semua_data,
                requests:false
            })
        })
        .catch(err =>{
            swal("Load data gagal, Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server", {
                icon: "error",
            }); 
        });
    }

    componentWillMount(){
        // this.getData()
    }

    onChangeStatus(e,el){
        this.setState({data: []})
        if(el.value==="10000"){
            this.setState({semua:true})
        } else { 
            this.setState({semua:false})
        }
        this.setState({
            status_val:el.value
        })
    }

    exportData(){
        printJS({
            printable: 'print_data',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:'Rincian BP',
            targetStyle: [
                'margin',
                'color',
                'border-collapse',
                'border-spacing',
                'border-style',
                'border-style',
                'margin-bottom',
                'padding',
                'Label',
                'background'
            ]
        })
     }
    
    render() {
        
        return (
            <div>
                <div>
                    { this.state.requests &&
                        <div id="loading">
                            <center>
                                <p><img id="img" src={ loader } style={{"marginTop":"20%", "width": "80px", "height": "80px"}} /></p>
                                <div>
                                    <p style={{"color": "white", "fontSize": "18px", "fontWeight": "bold"}}>Tunggu sebentar...</p>
                                </div>
                            </center>
                        </div>
                    }
                <Message
                    error
                    header='*** Penting!'
                    content='Silahkan atur rentang tanggal kemudian tekan tombol download excel'
                />                   
                <Menu>
                    <Menu.Item>
                        <DateRangePicker
                            hideKeyboardShortcutsPanel
                            reopenPickerOnClearDates
                            showClearDates
                            minimumNights={0}
                            withPortal
                            showDefaultInputIcon
                            displayFormat="DD/MM/YYYY"
                            small={true}                              
                            numberOfMonths={2}
                            startDatePlaceholderText="Awal"
                            endDatePlaceholderText="Akhir"
                            startDateId="startDateId"
                            endDateId="endDateId"
                            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                        />
                    </Menu.Item>       
                    <Menu.Item>
                        <Button disabled={this.state.startDate===null && this.state.endDate===null}
                            color='green' size="small" onClick={this.onFilter}> 
                            <p>Download Excel</p>
                        </Button>
                    </Menu.Item>
                </Menu>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report_admin/RekeningLaporan.js